import { launchLucky6 } from 'services/api/lucky6Service';
import { ProviderGame } from './ProviderGame';

// Lucky Six, from our Lucky Six provider (repo tottalo-lucky6).
export const LuckySix = () => (
  <ProviderGame
    launch={launchLucky6}
    title="Lucky Six"
    labelKey="lucky_six_label"
    unavailableKey="lucky_six_unavailable"
    hostedSlip
  />
);
